import { EntityHolisticlock } from "../../entity/EntityHolisticlock";

export class DtoHolisticlocksDeleteRes extends EntityHolisticlock {
  public message: string | null = null;
}
